/* eslint-disable prefer-arrow-callback,no-var */
(function Factbox(window) {
  var factboxes = window.document.querySelectorAll('.tc_factbox');

  Array.prototype.forEach.call(factboxes, function factboxLoop(factbox) {
    var factboxGrandParent = factbox.parentNode.parentNode;
    var factboxHeight = factbox.offsetHeight;
    var factboxBodyHeight = factbox.querySelector('.tc_card__body').offsetHeight;
    var factboxButton;
    var buffer = 150;

    if (factboxBodyHeight > factboxHeight + buffer) {
      factboxButton = factbox.querySelector('.tc_linkmore');
      factboxButton.addEventListener('click', function footerClick() {
        if (factboxGrandParent.getAttribute('data-object-position')) {
          factboxGrandParent.setAttribute('data-object-position', 'default');
        }
        factbox.classList.toggle('js_factbox--open');
      });
      factbox.classList.add('js_factbox--toggle');
    } else {
      factbox.classList.add('js_factbox--notoggle');
    }
  });
}(window));
